import HGIcon from './HGIcon'

export default HGIcon

export { HGIcon }
